// Extracts the property name from a selector function at runtime.
// Usage: nameof<IMyType>(x => x.MyProperty) // returns 'MyProperty'
export function nameof<T>(param: (type: T) => any): string {
  const pattern = /\.([a-zA-Z0-9_]+)/g;
  const results = (param + '').match(pattern);
  if (results === null) {
    throw new Error('Cannot find return type for param (value: ' + param + ')');
  }
  let returnValue = results.join();
  return returnValue.split('.').join('');
}

export const hasClass = (eventTarget: EventTarget, className: string): boolean => {
  let element = eventTarget as Element;
  if (element) {
    return new RegExp(className).test(element.className);
  }
  return false;
};

export const isChildOf = (eventTarget: EventTarget, className: string): boolean => {
  let element = eventTarget as Element;
  while (element && element.parentElement) {
    if (hasClass(element.parentElement, className)) {
      return true;
    }
    element = element.parentElement;
  }
  return false;
};

const eq = (s1: string, s2: string): boolean => s1.toLowerCase() === s2.toLowerCase();

export const closest = (eventTarget: EventTarget, nodeName: string): Element | null => {
  let element = eventTarget as Element;
  while (element && element.parentElement) {
    if (eq(element.nodeName, nodeName) || eq(element.parentElement.nodeName, nodeName)) {
      return element.parentElement;
    }
    element = element.parentElement;
  }
  return null;
};
